import { Centrifuge, type SubscriptionOptions } from 'centrifuge'
import type { PushAuthResponse } from '@zendesk/zqa-services/users'

import config from '@/config'
import { api } from '@/api'

export type { Subscription } from 'centrifuge'

const url = `wss://${config.isAWS ? `${location.host}/qa` : `app.${config.domainRoot}`}/push/connection/websocket`

export const centrifuge = new Centrifuge(url, {
  // Reconnect backoff: start at 1s, cap at 20s to avoid hammering the server on outages.
  minReconnectDelay: 1000,
  maxReconnectDelay: 20000,
  // Treat the connection as broken if no server ping arrives within this window.
  maxServerPingDelay: 10000,
  async getToken() {
    const { token } = await api.get('push/authorize-connection').json<PushAuthResponse>()
    return token
  },
})

export function newSubscription(channel: string, metadata = {}, options: Partial<SubscriptionOptions> = {}) {
  return centrifuge.newSubscription(channel, {
    async getToken({ channel }) {
      const { token } = await api
        .post(`push/authorize-channel/${channel}`, { json: { metadata } })
        .json<PushAuthResponse>()
      return token
    },
    ...options,
  })
}
